// import {defaultLocale,localeOptions} from '../../config/defaultValues'

import {
  CHANGE_LOCALE,
  TENANTS,
	CURRENT_TENANT,
	LOADER
} from '../actions';

const INIT_STATE = {
  locale: localStorage.getItem('__current_locale') || window.tenant.defaultLocale,
  tenants: JSON.parse(localStorage.getItem('tenants')),
	currentTenant: JSON.parse(localStorage.getItem('current_tenant')),
	loader: false
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_LOCALE:
      return { ...state, locale:action.payload};
    case TENANTS:
			return { ...state, tenants:action.payload};
		case CURRENT_TENANT:
			return { ...state, currentTenant:action.payload};
		case LOADER:
			return { ...state, loader:action.payload};
		default: return { ...state };
	}
}